<table mat-table aria-label="tableau vitrine du club" [dataSource]="dataSource" matSort multiTemplateDataRows>

  <ng-container matColumnDef="offerName">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="offername">
      Nom de l'offre
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element?.offer?.offerName}} </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="date">
      Date de la session
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element?.hasSession ? element?.sessionStartDate : 'Offre sans session'}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="status">
      Statut de la réservation
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element.bookingGlobalStatus}} </td>
  </ng-container>

  <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="price">
      Prix
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element?.bookedSessionAmount}}€ </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" >
  </tr>
</table>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [color]="color">
</mat-paginator>
